import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';

import CaseManagementHistory from '../CaseManagementHistory';

const noop = () => {};

const CaseManagementHistoryCard = ({ params }) => (
  <Card className="crm-management-history-card-container">
    <CardBody>
      <div className="crm-history-tabs">
        <div className="crm-tab-active">
          Historial de Gestiones
        </div>
      </div>
      <CaseManagementHistory params={params} setManagements={noop} />
    </CardBody>
  </Card>
);

CaseManagementHistoryCard.propTypes = {
  params: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

CaseManagementHistoryCard.defaultProps = {
  params: '',
};

export default CaseManagementHistoryCard;
